module.exports = __webpack_public_path__ + "img/image_4.032de507.png";